<template>
  <div>
    <LoadingSpinner
      v-if="
        $store.state.remittanceLoaded === true ||
        $store.state.loaded === false ||
        $store.state.loadingFundedAndUnfunded === true
      "
      class="flex h-full"
    />
    <div v-else class="">
      <div class=""></div>
      <div class="md:flex">
        <div class="md:flex md:w-[50%] md:mr-3 mb-3 md:mb-0">
          <div
            class="drop-shadow-md bg-[#E3FEEC] md:w-[50%] p-3 md:mr-3 mb-3 md:mb-0"
          >
            <font-awesome-icon
              class="text-[#55AB68]"
              icon="fa-solid fa-credit-card"
            />
            <p class="text-[#55AB68]">Total Payment</p>
            <h3>
              {{ $store.state.getRemittanceData?.amount_remitted || "0" }}
            </h3>
          </div>
          <div class="drop-shadow-md bg-[#FBEBF4] md:w-[50%] p-3">
            <font-awesome-icon
              class="text-[#09518c]"
              icon="fa-solid fa-gears"
            />
            <p class="text-[#09518c]">Unprocessed Payment</p>
            <h3>
              {{ $store.state.getRemittanceData?.amount_unprocessed || "0" }}
            </h3>
          </div>
        </div>
        <div class="md:flex md:w-[50%] mb-3 md:mb-0">
          <div
            class="drop-shadow-md bg-[#F0F4F5] md:w-[50%] p-3 md:mr-3 mb-3 md:mb-0"
          >
            <font-awesome-icon icon="fa-solid fa-user-group" />
            <p>Total Employees</p>
            <h3>{{ $store.state.fundedAndUnfunded.total }}</h3>
            <small class="text-sm">
              {{ $store.state.fundedAndUnfunded.monthly_pin }}
              New PIN for the month
            </small>
          </div>
          <div class="drop-shadow-md bg-[#F0ECFD] md:w-[50%] p-3">
            <font-awesome-icon
              class="text-[#6D49ED]"
              icon="fa-solid fa-right-to-bracket"
            />
            <p class="text-[#6D49ED]">Total Funded Employee</p>
            <h3>{{ $store.state.fundedAndUnfunded.funded }}</h3>
            <small class="text-sm">
              {{ $store.state.fundedAndUnfunded.stat }}
              % are funded
            </small>
          </div>
        </div>
      </div>
      <div class="my-6 lg:my-14 rmu">
        <h3 class="text-[#09518C]">Relationship Manager</h3>
        <div class="border w-fit p-1">
          <span class="mr-[16px]" id="rmu_name">
            {{ $store.state.getLoggedInUser?.rmu_name }}
            <!-- {{ $store.state.getLoggedInUser?.rmu_code }} -->
            <font-awesome-icon
              @click="copyText('rmu_name')"
              class="text-[#8dc63f] cursor-pointer ml-2"
              icon="fa-solid fa-clone"
            />
          </span>
          <span class="mr-[16px]" id="rmu_mobile">
            {{ $store.state.getLoggedInUser?.rmu_mobile }}
            <font-awesome-icon
              @click="copyText('rmu_mobile')"
              class="text-[#8dc63f] cursor-pointer"
              icon="fa-solid fa-clone"
            />
          </span>
          <span id="rmu_email">
            {{ $store.state.getLoggedInUser?.rmu_email }}
            <font-awesome-icon
              @click="copyText('rmu_email')"
              class="text-[#8dc63f] cursor-pointer"
              icon="fa-solid fa-clone"
            />
          </span>
        </div>
      </div>
      <div class="p-2 hover:bg-slate-100">
        <div>
          <div class="font-bold text-2xl text-[#09518C]">
            Remittance History
          </div>
          <div class="text-[#09518C] text-sm">
            Showing your latest remittance history
          </div>
        </div>
        <BarChart v-if="$store.state.loaded" />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import BarChart from "@/components/charts/barChart";
export default {
  components: {
    LoadingSpinner,
    BarChart,
  },
  methods: {
    copyText(id) {
      {
        var r = document.createRange();
        r.selectNode(document.getElementById(id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .rmu span {
    font-size: 14px;
  }
}
@media (min-width: 1024px) {
  .rmu span {
    font-size: 16px;
  }
}
</style>
